module.exports = (__parcel__import__("./" + require('./helpers/bundle-manifest').resolve("bV2pE"))).then(() => parcelRequire('13hJX'));